import React from 'react';
import { InputCheckbox } from '../../../Inputs';
import TableRow from '../../TableRow/TableRow';

const ResidentialRefinanceLenderPremiumBody = ({
  assessmentRecoupmentCharge,
  taxDeletion,
  notDuePayable,
  t17LenderResult,
  t19LenderResult,
  t28LenderResult,
  t33LenderResult,
  t36LenderResult,
  t39LenderResult,
  t42LenderResult,
  t42_1LenderResult,
  taxCertificateFee,
  settlementClosingFee,
  documentPreparationTransferLien,
  eRecordingFee,
  estimatedRecordingFee,
  checkboxValues,
  handleInputChange,
  totals,
}) => {
  // destructuring the totals
  const {
    totalAdjustedPremium,
    totalLenderInsuranceAndServicesFee,
    totalLenderPolicyPremium,
  } = totals;

  return (
    <tbody>
      <TableRow
        type="checkbox"
        label="Adjusted Premium"
        valueType="currency"
        value={totalAdjustedPremium}
      />
      <TableRow
        type="checkbox"
        label="Policy Guaranty Fee"
        valueType="currency"
        value={assessmentRecoupmentCharge}
      />
      <TableRow
        type="checkbox"
        label="Tax Deletion"
        valueType="currency"
        value={taxDeletion}
      />
      <TableRow
        type="checkbox"
        label="Not Yet Due and Payable"
        valueType="currency"
        value={notDuePayable}
      />
      <TableRow
        type="checkbox"
        label="T-17 (PUD Endorsement)"
        valueType="currency"
        value={t17LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_17_lender}
          handleInputChange={handleInputChange}
          id="t_17_lender"
          name="t_17_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-19 (Rest/Encro/Mineral)"
        valueType="currency"
        value={t19LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_19_lender}
          handleInputChange={handleInputChange}
          id="t_19_lender"
          name="t_19_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-28 (Condo)"
        valueType="currency"
        value={t28LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_28_lender}
          handleInputChange={handleInputChange}
          id="t_28_lender"
          name="t_28_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-33 (ARM)"
        valueType="currency"
        value={t33LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_33_lender}
          handleInputChange={handleInputChange}
          id="t_33_lender"
          name="t_33_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-36 (EPA)"
        valueType="currency"
        value={t36LenderResult}
      />
      <TableRow
        type="checkbox"
        label="T-39 (Balloon)"
        valueType="currency"
        value={t39LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_39_lender}
          handleInputChange={handleInputChange}
          id="t_39_lender"
          name="t_39_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-42 (Home Equity)"
        valueType="currency"
        value={t42LenderResult}
      />
      <TableRow
        type="checkbox"
        label="T-42.1 (Home Equity Supplemental)"
        valueType="currency"
        value={t42_1LenderResult}
      />
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Total Lender Policy Premium"
        valueType="currency"
        value={totalLenderPolicyPremium}
      />
      <TableRow
        type="checkbox"
        label="Tax Certificate Fee"
        valueType="currency"
        value={taxCertificateFee}
      />
      <TableRow
        type="checkbox"
        label="Settlement/Closing Fee"
        valueType="currency"
        value={settlementClosingFee}
      />
      <TableRow
        type="checkbox"
        label="Document Preparation of One Transfer of Lien"
        valueType="currency"
        value={documentPreparationTransferLien}
      />
      <TableRow
        type="checkbox"
        label="eRecording Fee"
        valueType="currency"
        value={eRecordingFee}
      />
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Total Lender's Title Insurance & Title Services Fee"
        valueType="currency"
        value={totalLenderInsuranceAndServicesFee}
      />
      <TableRow
        type="checkbox"
        label="Estimated Recording Fees"
        subLabel="* Per document charge is $26 for the first page, $4 for each additional page"
        valueType="currency"
        value={estimatedRecordingFee}
      />
    </tbody>
  );
};

export default ResidentialRefinanceLenderPremiumBody;
